<template>
    <v-app>
        <v-navigation-drawer v-if="isAuthorizedSuccessfully"
                             v-model="drawer"
                             app>
            <v-list dense
                    nav>
                <div v-if="isClient && isAdministrator">
                    <v-list-item>
                        <v-list-item-title>Пользователь:</v-list-item-title>
                    </v-list-item>
                </div>

                <div v-if="isClient">
                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'dayPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-home</v-icon>
                        </template>

                        <v-list-item-title>День</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'notesPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-notebook-edit</v-icon>
                        </template>

                        <v-list-item-title>Заметки</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'ideasPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-lightbulb-on-outline</v-icon>
                        </template>

                        <v-list-item-title>Идеи</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'settingsPage' }">
                        <template v-slot:prepend>
                            <v-icon>mdi-account-cog-outline</v-icon>
                        </template>

                        <v-list-item-title>Настройки</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'groupsPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-account-multiple</v-icon>
                        </template>

                        <v-list-item-title>Мои группы</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="isGroupInfoPage"
                                 link
                                 color="primary"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-account-multiple</v-icon>
                        </template>

                        <v-list-item-title>
                            Группа
                            <span v-if="selectedGroupName">
                                {{ selectedGroupName }}
                            </span>
                        </v-list-item-title>
                    </v-list-item>
                </div>

                <v-list-item v-if="isChangePasswordPage"
                             color="primary"
                             :to="{ name: 'changePasswordPage' }">
                    <template v-slot:prepend>
                        <v-icon>mdi-lock</v-icon>
                    </template>

                    <v-list-item-title>Пароль</v-list-item-title>
                </v-list-item>

                <div v-if="isClient && isAdministrator">
                    <v-divider />

                    <v-list-item>
                        <v-list-item-title>Администрирование:</v-list-item-title>
                    </v-list-item>
                </div>

                <div v-if="isAdministrator">
                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'mainAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-home-analytics</v-icon>
                        </template>

                        <v-list-item-title>Главная</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'usersAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-account</v-icon>
                        </template>

                        <v-list-item-title>Пользователи</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'groupsAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-account-multiple</v-icon>
                        </template>

                        <v-list-item-title>Группы</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'groupsAndUsersAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-account-group</v-icon>
                        </template>

                        <v-list-item-title>Члены групп</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'invitationsAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-ticket</v-icon>
                        </template>

                        <v-list-item-title>Приглашения</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'authorsAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-account-cowboy-hat</v-icon>
                        </template>

                        <v-list-item-title>Авторы</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'citationsAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-text-box-outline</v-icon>
                        </template>

                        <v-list-item-title>Цитаты</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'sportsAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-tennis</v-icon>
                        </template>

                        <v-list-item-title>Спорт</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'hobbiesAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-telescope</v-icon>
                        </template>

                        <v-list-item-title>Хобби</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'foodAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-food-turkey</v-icon>
                        </template>

                        <v-list-item-title>Блюда</v-list-item-title>
                    </v-list-item>

                    <v-list-item link
                                 color="primary"
                                 :to="{ name: 'dessertsAdminPage' }"
                                 exact>
                        <template v-slot:prepend>
                            <v-icon>mdi-cake-variant</v-icon>
                        </template>

                        <v-list-item-title>Десерты</v-list-item-title>
                    </v-list-item>
                </div>

            </v-list>
        </v-navigation-drawer>

        <v-app-bar v-if="isAuthorizedSuccessfully"
                   app
                   :elevation="7"
                   height="80"
                   dark>
            <v-app-bar-nav-icon class="my-auto"
                                color="primary"
                                @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <div class="d-flex justify-space-between w-100 ml-3 my-0">
                <div class="my-auto">
                    <v-app-bar-title>
                        <div class="text-h4 d-none d-sm-flex text-primary">Day To Day</div>
                        <div class="d-sm-none text-primary">DTD</div>
                        <div class="mt-n1 d-none d-sm-flex text-h6 text-primary">изо дня в день :)</div>
                    </v-app-bar-title>
                </div>

                <div class="my-auto">
                    <div v-if="isXS || !isDayPage || (!selectedDateTime && !isDateRange)">
                        <v-tooltip location="bottom"
                                   text="Текущие дата и время">
                            <template v-slot:activator="{ props }">
                                <div v-bind="props"
                                     class="d-flex flex-column flex-sm-row text-h6 text-primary">
                                    <div class="active-text"
                                         @click="selectDate">
                                        {{ getDate(currentDateTime) }}
                                    </div>
                                    <div class="d-none d-sm-flex">,&nbsp;</div>
                                    <div class="align-self-center align-self-sm-start">
                                        {{ getTime(currentDateTime) }}
                                    </div>
                                </div>
                            </template>
                        </v-tooltip>
                    </div>
                    <div v-else
                         class="text-h6 d-flex flex-column px-2">
                        <v-tooltip location="bottom"
                                   text="Текущие дата и время">
                            <template v-slot:activator="{ props }">
                                <div v-bind="props"
                                     class="text-primary active-text"
                                     @click="selectDate">
                                    {{ getDate(currentDateTime) }}, {{ getTime(currentDateTime) }}
                                </div>
                            </template>
                        </v-tooltip>
                        <div v-if="!isDateRange"
                             class="text-secondary"
                             @click="selectDateRange">
                            <v-tooltip location="bottom"
                                       text="Выбранная дата">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        Выбрано: {{ getDate(selectedDateTime) }}
                                    </div>
                                </template>
                            </v-tooltip>
                        </div>
                        <div v-else
                             class="text-secondary active-text"
                             @click="selectDateRange">
                            <v-tooltip location="bottom"
                                       text="Выбранный диапазон дат">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        {{ getDateDay(startDateTime) }}&nbsp;{{ getDateMonth(startDateTime) }}&nbsp;-&nbsp;{{ getDateDay(endDateTime) }}&nbsp;{{ getDateMonth(endDateTime) }}
                                    </div>
                                </template>
                            </v-tooltip>
                        </div>
                    </div>
                </div>

                <div class="my-auto">
                    <v-menu offset-y left>
                        <template v-slot:activator="{ isActive: showMenu, props }">
                            <v-btn flat
                                   :ripple="true"
                                   color="primary"
                                   class="text-h6 text-uppercase pl-2 pr-0 mr-4"
                                   v-bind="props"
                                   @click="showMenu = true">
                                <span class="d-none d-sm-flex">{{ userName }}</span>
                                <v-icon class="d-sm-none" dark :title="userName">mdi-account</v-icon>
                                <v-icon dark>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item class="d-sm-none">
                                <v-list-item-title class="text-uppercase font-weight-bold text-primary">{{ userName }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item @click="selectTheme">
                                <template v-slot:prepend>
                                    <v-icon>mdi-palette</v-icon>
                                </template>

                                <v-list-item-title>Выбрать палитру</v-list-item-title>
                            </v-list-item>

                            <v-list-item :to="{ name: 'changePasswordPage' }">
                                <template v-slot:prepend>
                                    <v-icon>mdi-lock</v-icon>
                                </template>

                                <v-list-item-title>Изменить пароль</v-list-item-title>
                            </v-list-item>

                            <v-list-item @click="logout">
                                <template v-slot:prepend>
                                    <v-icon>mdi-exit-to-app</v-icon>
                                </template>

                                <v-list-item-title>Выйти</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </v-app-bar>

        <v-main>
            <v-container fluid :class="{'fill-height': isFillHeight}">
                <router-view id="view" />
            </v-container>
        </v-main>
    </v-app>

    <ThemeChanger />

    <DateChanger />

    <DateRangeChanger />

    <MessagesDemonstrator />

    <v-overlay :model-value="isLoading"
               class="align-center justify-center">
        <v-progress-circular indeterminate
                             color="primary"
                             size="128"
                             width="8" />
    </v-overlay>
</template>

<script>
    import { mapState, mapGetters } from "vuex";

    import ThemeChanger from "@/components/ThemeChanger.vue";
    import DateChanger from "@/components/DateChanger.vue";
    import DateRangeChanger from "@/components/DateRangeChanger.vue";
    import MessagesDemonstrator from "@/components/MessagesDemonstrator.vue";

    export default {
        name: "App",

        components: {
            ThemeChanger,
            DateChanger,
            DateRangeChanger,
            MessagesDemonstrator
        },

        data() {
            return {
                drawer: null,
                showMenu: false
            };
        },

        created() {
            this.$store.dispatch("loadUserSettings");

            this.$store.commit("setSelectedDateTime", null);

            window.setInterval(
                () => this.$store.commit("setCurrentDateTime"),
                10000);
        },

        computed: {
            ...mapGetters(["isLoading"]),

            ...mapState([
                "toasts",
                "isAuthorized", "isAdministrator", "isClient",
                "userName", "userRoles",
                "currentLocale",
                "currentDateTime", "selectedDateTime", "startDateTime", "endDateTime"
            ]),

            isDateRange() {
                return this.startDateTime && this.endDateTime;
            },

            gridName() {
                return this.$vuetify.display.name;
            },

            isXS() {
                return this.gridName === "xs";
            },

            isSM() {
                return this.gridName === "sm";
            },

            isSmallWidth() {
                return this.gridName === "xs"
                    || this.gridName === "sm";
            },

            pageName() {
                return this.$route.name;
            },

            isFillHeight() {
                return this.pageName === "loginPage"
                    || this.pageName === "resetPasswordPage"
                    || this.pageName === "registrationPage"
                    || this.pageName === "confirmationPage";
            },

            isLoginLayout() {
                return this.pageName === "loginPage"
                    || this.pageName === "registrationPage";
            },

            isClientPage() {
                return this.pageName === "dayPage"
                    || this.pageName === "settingsPage";
            },

            isDayPage() {
                return this.pageName === "dayPage";
            },

            isAuthorizedSuccessfully() {
                return !this.isLoginLayout && this.isAuthorized;
            },

            isChangePasswordPage() {
                return this.pageName === "changePasswordPage";
            },

            isGroupInfoPage() {
                return this.pageName === "groupInfoPage";
            },

            selectedGroupName() {
                if (!this.isGroupInfoPage) {
                    return null;
                }

                return this.$store.state.selectedGroup?.name;
            },

            colorThemeName() {
                return this.$store.state.userSettings?.colorThemeName;
            }
        },

        watch: {
            colorThemeName(newValue) {
                if (!newValue) {
                    return;
                }

                this.$vuetify.theme.global.name = newValue;
            }
        },

        methods: {
            selectTheme() {
                this.$store.commit("setShowThemeDialog", true);
            },

            selectDate() {
                this.$store.commit("setShowDateDialog", true);
            },

            selectDateRange() {
                this.$store.commit("setShowDateRangeDialog", true);
            },

            logout() {
                this.$store.dispatch("logout").then(() => {
                    window.location.href = "/";
                });
            },

            getDate(dateTime) {
                return dateTime.setLocale(this.currentLocale).toFormat("d MMMM");
            },

            getDateDay(dateTime) {
                return dateTime.setLocale(this.currentLocale).toFormat("d");
            },

            getDateMonth(dateTime) {
                return dateTime.setLocale(this.currentLocale).toFormat("MMMM");
            },

            getTime(dateTime) {
                return dateTime.setLocale(this.currentLocale).toFormat("HH:mm");
            }
        }
    };
</script>

<style lang="scss">
    .active-text {
        cursor: pointer;
    }
</style>